define.alias("shared/components/shared/post/copy/modal", "settings/components/shared/post/copy/modal/index");